import React from 'react';
import ReviewCard from '../components/Reviews/ReviewCard';
import {reviews} from '../content/reviews/reviews';
import './Reviews.css';

function Reviews() {
  return (
    <div className='Reviews'>
      <div className='reviewspage'>
        <h1>Reviews</h1>

        <h2 className='my-3 my-sm-4 my-lg-5 px-3'>
          I'm so grateful for all these lovely comments from other writers and
          readers
        </h2>

        <div className='row m-auto'>
          {reviews.map((r) => (
            <div
              key={r.id}
              className='col-6 col-md-4 col-lg-3 p-2 p-sm-3'>
              <ReviewCard
                item={r}
                showStars
              />
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

export default Reviews;
